import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import DownloadButton from '../../../../components/Button/DownloadButton';
import {useParams} from 'react-router-dom';
import MusicPreviewBtn from '../../../../components/music/MusicPreviewBtn';
import {useRqGetDemoStingerById} from '../../../../react_query/demoStingerQuery';
import DemoStingerContent from './DemoStingerContent';
import {RequestType} from '../../../../dto/demoStingerFulfilment.dto';
import {apiPost} from '../../../../axiosConfig';
import DialogApiRequestStatus from '../../../../components/dialogs/DialogApiRequestStatus';
import {useCallback, useEffect, useState} from 'react';
import {broadCastCloseTab} from '../../../../react_query/tasks/ListTasks';
import AssignTaskButton from '../../../../components/my-task/AssignTaskButton';

const DemoStingerProductRep = () => {
  const task = useParams();
  const taskId = Number(task.task_id);
  const {data, isError, isFetched} = useRqGetDemoStingerById(taskId);
  const [isPreview, setIsPreview] = useState<boolean>(false);
  const [requestType, SetRequestType] = useState<number>(0);
  const [apiState, setApiState] = useState({
    status: '',
    error: null,
    successMsg: '',
  });

  const handleComplete = useCallback(() => {
    setApiState({status: 'pending', error: null, successMsg: ''});
    const url =
      data?.values.request_type === 5
        ? `/v1/task/${taskId}/demo-stinger/completeDemoTask`
        : `/v1/task/${taskId}`;

    apiPost(url)
      .then(() => {
        setApiState({
          status: 'success',
          error: null,
          successMsg: 'Task been updated',
        });
      })
      .catch(error => {
        setApiState({
          status: 'error',
          error,
          successMsg: '',
        });
      });
  }, [taskId, setApiState, data]);
  const handleCancel = useCallback(() => {
    broadCastCloseTab();
  }, []);

  const handleEdit = useCallback(() => {
    setApiState({
      status: '',
      error: null,
      successMsg: '',
    });
  }, []);
  // Request type 5 refer to Tnn Demo
  useEffect(() => {
    if (data?.values.request_type === 5) {
      SetRequestType(data.values.request_type);
    }
  }, [data]);

  const isTnn = Number(data?.values.request_type) === RequestType.TNN_DEMO;
  const downloadFileName =
    (isTnn && data?.values.advertiser) ||
    data?.values.media_track?.track_name ||
    data?.values?.name ||
    '';

  return (
    <Card>
      {data?.values.request_type === 5 && (
        <AssignTaskButton
          isPreview={isPreview}
          setIsPreview={setIsPreview}
          requestType={requestType}
        />
      )}
      <CardHeader title={`Demo Stinger Fulfillment `}></CardHeader>
      <CardContent style={{margin: 10}}>
        {data && !isError && isFetched && (
          <DemoStingerContent values={data.values} />
        )}
        <Typography variant='h5'>File Details</Typography>
        <TableContainer>
          <Table
            sx={{
              '.MuiTableCell-root, .MuiTableRow-root': {
                border: 'none !important',
                padding: '6px 0',
              },
            }}>
            <TableBody>
              <TableRow>
                <TableCell>
                  <Typography variant='subtitle1' className='text-white-50'>
                    Name
                  </Typography>
                  <Typography variant='subtitle1'>
                    {data?.values.media_track.track_name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant='subtitle1' className='text-white-50'>
                    Play
                  </Typography>
                  {data?.values && (
                    <MusicPreviewBtn
                      id={data?.values.id}
                      url={data?.values.media_track.url}
                      track_name={
                        data?.values.media_track.track_name ||
                        data?.values?.name
                      }
                      track_artist={data?.values.media_track.track_artist}
                    />
                  )}
                </TableCell>
                <TableCell align='center'>
                  <Typography variant='subtitle1' className='text-white-50'>
                    Download
                  </Typography>
                  {data?.values.media_track?.url && (
                    <DownloadButton
                      filename={downloadFileName}
                      url={data.values.media_track.url}
                    />
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '10vh',
          }}>
          <Button variant='outlined' onClick={handleComplete}>
            Complete
          </Button>
        </Box>
        {apiState.status !== '' ? (
          <DialogApiRequestStatus
            apiState={apiState}
            onRetry={handleComplete}
            onEdit={handleEdit}
            onClose={handleCancel}
          />
        ) : null}
      </CardContent>
    </Card>
  );
};

export default DemoStingerProductRep;
